const notes = {
    isBusy: false,
    isOpen: false,
    activeNote: [],
};

export default notes;
